import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import InputError from '~/components/UI/Inputs/InputError.vue';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.component('InputError', InputError);
